import { useLang } from 'hooks/lang';

import { PropertyWithIcon } from 'components/PropertyWithIcon';
import { DeviceIcon } from 'components/Icons';

import { DEVICE_OPTIONS } from 'utils/constants';
import { listGet } from 'utils/array';

export function DeviceTarget({ value }: { value: string }) {
  const { t } = useLang();

  const config = listGet(DEVICE_OPTIONS, value);

  const Icon = config?.icon ?? DeviceIcon;

  return (
    <PropertyWithIcon
      value={config?.getLabel(t) || 'N/A'}
      name={t('device-target')}
      icon={<Icon />}
    />
  );
}
